<template>
  <div class="container mb060">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>追加認証</HeadingOne>

    <ErrorsAlert :errors="errors" class="_mt-md-60 _mt-sm-60"></ErrorsAlert>

    <HeadingTwo class="head-icon _mt-md-60 _mt-sm-50">
      ワンタイムパスワード送信
      <router-link
        :to="{ name: 'sv060', hash: '#section_01' }"
        target="_blank"
        @click="trackGtmEvent('【click】ステップ', 'ステップ①')"
      >
        <img src="@/assets/images/mb/common/question.svg" />
      </router-link>
    </HeadingTwo>

    <section class="_mb-md-60 _mb-sm-35">
      <ContactBox class="_mb-md-10 _mb-sm-10">
        <CardHeader class="_pb-md-0 _pb-sm-0">安全・安心にご利用いただくために</CardHeader>
        <CardBody>
          <p class="_mb-md-0 _mb-sm-0">
            第三者による不正な使用や情報変更を防ぐため、au PAY スマートローンではSMSを使用した追加認証を導入しております。
          </p>
        </CardBody>
      </ContactBox>
      <ListGroup v-if="hasAuPhone" class="-note">
        <ListItem class="-note">
          現在ご利用の電話番号と異なるお客さまは大変恐れいりますが、au
          IDにご登録のお電話番号を変更いただきますようお願いいたします。<br />
          <a href="https://www.au.com/my-au/" target="_blank">My auはこちら ＞</a>
        </ListItem>
      </ListGroup>
    </section>

    <p>ワンタイムパスワードをご登録の電話番号にお送り致します。</p>
    <section>
      <TableGroup>
        <TableBox class="_mb-10">
          <TableBody>
            <TableRow>
              <TableHeader> ワンタイムパスワード送信先 </TableHeader>
              <TableData>
                <!-- au電話番号あり -->
                <template v-if="hasAuPhone"> {{ userData.phone_au_1 }}-XXXX-{{ userData.phone_au_3 }} </template>
                <template v-else>
                  {{ userData.phone_mobile_1 }}-XXXX-{{ userData.phone_mobile_3 }}
                  <BtngroupSingle class="_textleft _mt-10">
                    <BtnHelp router-name="mb065"> 変更する </BtnHelp>
                  </BtngroupSingle>
                </template>
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>

      <form novalidate @submit.prevent="submitOtpSmsSend">
        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" @click.prevent="submitOtpSmsSend"> ワンタイムパスワードを送信する </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="mb001"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </form>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import { getUserDataLambdaInvoke, otpSmsSendLambdaInvoke } from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import { setHasPhoneMobile, checkMobilePhoneDigits } from "@/utils/UserData";

import { trackGtmEvent } from "@/utils/Gtm";

import ErrorsAlert from "@/components/alert/ErrorsAlert";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import ContactBox from "@/components/box/ContactBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "../components/card/CardBody";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnHelp from "@/components/button/BtnHelp";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";

export default {
  name: "Mb060",
  components: {
    ErrorsAlert,
    BtnBack,
    BtnMain,
    BtngroupSingle,
    BtngroupDouble,
    BtnHelp,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    ContactBox,
    CardHeader,
    CardBody,
    HeadingOne,
    HeadingTwo,
    BreadcrumbGroup,
    ListGroup,
    ListItem,
  },
  setup() {
    setMeta({
      title: "追加認証・ワンタイムパスワード送信",
      description: "",
      keywords: "",
    });

    return {
      trackGtmEvent,
      setHasPhoneMobile,
      checkMobilePhoneDigits,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "追加認証",
          active: true,
        },
      ],
      errors: {},
      isDisabled: false,
      pageId: this.$route.query.page_id,
      authKind: this.$route.query.auth_kind,
      userData: {
        phone_au_1: "",
        phone_au_2: "",
        phone_au_3: "",
        phone_mobile_1: "",
        phone_mobile_2: "",
        phone_mobile_3: "",
        user_session: "",
      },
      otpSmsSend: {
        message: "",
      },
    };
  },
  computed: {
    hasAuPhone() {
      return this.userData.phone_au_1 && this.userData.phone_au_2 && this.userData.phone_au_3;
    },
  },
  mounted() {
    try {
      getUserDataLambdaInvoke().then((res) => {
        for (let key in res) {
          if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
            this.userData[key] = res[key];
          }
        }

        const userData = this.hasAuPhone
          ? {
              phone1: this.userData.phone_au_1,
              phone2: this.userData.phone_au_2,
              phone3: this.userData.phone_au_3,
            }
          : {
              phone1: this.userData.phone_mobile_1,
              phone2: this.userData.phone_mobile_2,
              phone3: this.userData.phone_mobile_3,
            };

        if (!setHasPhoneMobile(userData.phone1, userData.phone2, userData.phone3)) {
          this.$router.push({ name: "mb065" });
        } else if (!checkMobilePhoneDigits(userData.phone1)) {
          this.$router.push({ name: "mb065" });
        }
      });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitOtpSmsSend: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};

        initCredentials()
          .then(() => {
            const userData = this.hasAuPhone
              ? {
                  phone_au_1: this.userData.phone_au_1,
                  phone_au_2: this.userData.phone_au_2,
                  phone_au_3: this.userData.phone_au_3,
                }
              : {
                  phone_mobile_1: this.userData.phone_mobile_1,
                  phone_mobile_2: this.userData.phone_mobile_2,
                  phone_mobile_3: this.userData.phone_mobile_3,
                };
            otpSmsSendLambdaInvoke(userData)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else if (Object.keys(this.errors).length === 0) {
                  let resBody = JSON.parse(res.body);
                  for (let key in resBody) {
                    if (Object.prototype.hasOwnProperty.call(this.otpSmsSend, key)) {
                      this.otpSmsSend[key] = resBody[key];
                    }
                  }
                  let pageName = this.pageId.toLowerCase().replace("-", "");
                  this.$router.push({ name: "mb061", query: { page_id: pageName, auth_kind: this.authKind } });
                } else {
                  this.$router.push({ name: "SessionTimeOut" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.TableData {
  > .red {
    color: $danger;
    font-weight: bold;
  }
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
.contact-box {
  > .card-body {
    justify-content: flex-start;
  }
}
.mb060 {
  .head-icon {
    :deep(.heading) {
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        width: 24px;
        height: 24px;
        margin-left: 8px;
        @media screen and (max-width: 767px) {
          width: 18px;
          height: 18px;
        }
        img {
          width: 100%;
        }
      }
    }
  }

  :deep(.contact-box) {
    border: 1px solid #cccccc;
    border-radius: 10px;
    margin: inherit;
  }

  .btn-main.-main {
    width: auto;
  }
}
</style>
